$(function () {
	const videos = document.querySelectorAll('[data-lazy-model-video]');
	if (!videos.length) return;
	const start = function (video) {
		if (!video.src) {
			video.src = video.dataset.lazyModelVideo;
			video.load();
		}
		const playing = video.play();
		if (playing) playing.catch(function () {});
	};
	if (!('IntersectionObserver' in window)) {
		videos.forEach(start);
		return;
	}
	const observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) start(entry.target);
			else entry.target.pause();
		});
	}, {rootMargin: '200px 0px'});
	videos.forEach(function (video) { observer.observe(video); });
});
